import { CaretDownFilled } from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition, selectTenantFunction, selectUserId } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { Material } from '../../../../models/material'
import { getNewNormalFrequencyCodeCalc, getNormalFrequencyCodeCalc, isTcmRecipeCategory, RecipeCategory } from '../../../../models/recipe'
import { Checks, Settings } from '../../../../models/setting'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { ItemCompletionType } from '../../../completion/completionSlice'
import { selectBooleanSetting } from '../../../settings/settingsSlice'
import { getQuicklyPrescribeBySpecialWayFn, getRecipeDetail, setBatchAddVisibel, setPageLoading } from '../recipeEditorSlice'
import { getRecipeList, selectRecipes } from '../recipeListEditorSlice'
import {
  RecipeItemFieldInput,
  RecipeItemFieldInputRef,
} from './RecipeItemFieldInput'
import { RecipeItemInput, RecipeItemInputRef } from './RecipeItemInput'
import styles from './RecipeItemSelect.module.css'
import { selectSettings } from '../../../user/setting/settingSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { getSetMealDetail } from '../../../setmeal/setmealSlice'
import { getNewAutoChangePriceDrugCount, getNewAutoChangePriceSplitDrugCount, getNewAutoChangePriceSplitUseDays, getNewAutoChangePriceUseDays, getOldAutoChangePriceDrugCount, getOldAutoChangePriceSplitDrugCount, getOldAutoChangePriceSplitUseDays, getOldAutoChangePriceUseDays } from '../../../../models/RecipeItemAutoChangePrice'

interface RecipeItemEditorProps {
  isMember?: boolean
  selectTag?: any // 光标选中
  tipCount?: any
  potionType?: number
  quickAddProjectLoading?: boolean
  onChange: (material: Material, ignoreStorage: boolean) => void
  addTC?: (
    materials: Material[],
    id?: any,
    category?: any,
    flag?: any,
    data?: any) => void
  quickAddProject?: () => void
  treatmentInsuranceCode?: any
  insuranceCode?: string
  category?: RecipeCategory
  includeAllTcm?: boolean
  data: any
  isCurePlanModa?: boolean
  kskdTag?: boolean
  ydkdFlag?: boolean
  disabled?: boolean
  discountFlag?: any
  treatmentId?: any
  recipeId?: any
  getCompletionType?: (v: any) => void
  patientPhone?: string
}

export const RecipeItemEditor = ({
  isMember = false,
  selectTag,
  tipCount, //帖数
  potionType,
  quickAddProjectLoading,
  onChange,
  addTC,
  quickAddProject,
  category,
  data,
  includeAllTcm = false,
  treatmentInsuranceCode,
  insuranceCode,
  isCurePlanModa = false,
  disabled = false,
  discountFlag,
  kskdTag = false,
  ydkdFlag = false,
  treatmentId,
  recipeId,
  getCompletionType,
  patientPhone,
}: RecipeItemEditorProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const ref = useRef<RecipeItemInputRef>(null)

  const buttonRef = useRef<HTMLElement>(null)

  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const recipes = useSelector(selectRecipes)

  const settings = useSelector(selectSettings)

  const createAutoFeeSwitch: any = useSelector(selectTenantFunction)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [material, setMaterial] = useState<Material | undefined>()

  useEffect(() => {
   console.log(material,"material")
  }, [material])

  const [isIgnoreStorage, setIsIgnoreStorage] = useState(false)

  const [selectData, setSelectData] = useState<any>()

  const [discountPrice, setDiscountPrice] = useState<any>('0.00')

  const [discountAllPrice, setDiscountAllPrice] = useState<any>('0.00')

  const [tcmDiscountPrice, setTCMDiscountPrice] = useState<any>('0.00')

  const [tcmDiscountAllPrice, setTCMDiscountAllPrice] = useState<any>('0.00')

  const [selectDoseUnit, setSelectDoseUnit] = useState<any>('') //常用用量单位

  const [completionType, setCompletionType] = useState(
    category === RecipeCategory.Dispose && hisVersion != 1 ? ItemCompletionType.ZLCL : ItemCompletionType.Inventory
  )

  const [isSplitModalVisible, setIsSplitModalVisible] = useState(false)

  const useSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.UseSpecifiedBatch)
  )

  const ignoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.IgnoreStorage)
  )

  const tcmUseSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmUseSpecifiedBatch)
  )

  const tcmIgnoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmIgnoreStorage)
  )

  const allowedToChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.ChangePrice)
  )

  const autoChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.AutoChangePrice)
  )

  const [calc, setCalc] = useState(0) //记录频次的修改

  const [isTraceCodeTag, setIsTraceCodeTag] = useState(false) // 是否是8开头的追溯码

  const [traceCodeData, setTraceCodeData] = useState<any>() // 接口返回8开头的拆零价格

  const [traceCode, setTraceCode] = useState<any>() // 8开头的追溯码

  const [isTraceCodeLoading, setIsTraceCodeLoading] = useState(false) // 追溯码接口加载中，防止重复调用


  const completionTypeUserId = `completionType_${userId}`

  const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')

  const localData: any = JSON.parse(
      localStorage.getItem('retailPreferencesSettingData') || '{}')
      
  const wbTag = allPersonalPreferences?.records?.filter((v: any) => v?.code == '5')?.[0]

  const KSKDKFLX = allPersonalPreferences?.records?.find((v: any) => v?.code == '2003')?.codeName 

  const kflx = KSKDKFLX?.toString() ? Number(KSKDKFLX) : localData?.[completionTypeUserId]

  const materialsCategoryFlag = material?.materialsCategory == 1 || material?.materialsCategory == 2 || material?.materialsCategory == 4

 useEffect(() => {
      if (
        category === RecipeCategory.Examination ||
        category === RecipeCategory.Treatment || 
        category === RecipeCategory.TcmTreat
      ) {
        setCompletionType(ItemCompletionType.Treatment)
   } else if (category === RecipeCategory.Dispose) {
     setCompletionType(ItemCompletionType.ZLCL)
   } else {
     if (location.pathname == '/retail' && category == RecipeCategory.Medicine) {
       if (kflx == 1) {
         setCompletionType(ItemCompletionType.Treatment)
       } else {
         setCompletionType(ItemCompletionType.Auto)
       }
     } else if (location.pathname == '/pharmacy/retail' && category === RecipeCategory.Medicine) {
       if (category == RecipeCategory.Medicine || category == RecipeCategory.Others) {
         setCompletionType(ItemCompletionType.Auto)
       } else {
         setCompletionType(ItemCompletionType.Auto)
       }
     } else {
       setCompletionType(ItemCompletionType.Auto)
     }
   }
   form.resetFields()
   form.setFieldsValue({
      discount: 100,
    })
  }, [category, kflx])
  
  const handler = (e: KeyboardEvent) => {
    if (!isSplitModalVisible) {
      document.removeEventListener('keydown', handler)
      return
    }
    if (e.key === '1' || e.key === '2') {
      // 阻止默认行为，避免数字被输入到关闭弹框后聚焦的数量输入框中
      e.preventDefault()
      e.stopPropagation()
      if(isTraceCodeTag) {
        traceCodeHandler(e.key === '1' ? 1 : 0)
      }
      setIsSplitModalVisible(false)
      document.removeEventListener('keydown', handler)
      setFieldsFromMaterial(material, e.key === '1')
      // if (settings?.[Checks.MLKG] === '1' && completionType != ItemCompletionType.Treatment) {
      //   // 非诊疗跳天数
      //   setTimeout(() => {
      //     const useDaysIndex = names.indexOf('useDays')
      //     const ref = refs.current[useDaysIndex !== -1 ? useDaysIndex : names.length - 1]
      //     ref?.focus()
      //   }, 10)
      // } else {
        setTimeout(() => {
          const ref = refs.current[names.length - 1]
          ref?.focus()
          // ref?.select()
        }, 300)
      // }
    }
  }

  const traceCodeHandler = (splitTag: number) => { 
    setIsTraceCodeTag(false)
    dispatch(getQuicklyPrescribeBySpecialWayFn({
      type: 0,
      code: traceCode,
      splitTag: splitTag,
      treatmentId: Number(treatmentId),
      recipeId: Number(recipeId),
      createAutoFeeSwitch: createAutoFeeSwitch?.[56] == 'true' ? true : false
    })).then(unwrapResult)
    .then(async (res: any) => {
      if(res.code == 201) {
        notification.error({
          message: res.msg,
          duration: 3,
        })
        form.resetFields()
        return
      }
      if (res.code == 200) {
        if (res?.usedSplitCount > 0 || res?.usedWholeCount > 0) {
          message.open({
            type: 'warning',
            content:
              <>
                <span>{res?.name}</span>
                <span style={{margin:'0 4px'}}>追溯码</span>
                <span>{res?.traceCode}</span>
                <span style={{margin:'0 4px'}}></span>
                {res?.usedSplitCount > 0 && (
                  <>
                    <span>拆零已录入</span>
                    <span style={{color:'#ff9f39',fontWeight:'bold'}}>{res?.usedSplitCount}</span>
                    <span>次</span>
                  </>
                )}
                {res?.usedSplitCount > 0 && res?.usedWholeCount > 0 && (
                  <span style={{margin:'0 4px'}}>，</span>
                )}
                {res?.usedWholeCount > 0 && (
                  <>
                    <span>整存已录入</span>
                    <span style={{color:'#ff9f39',fontWeight:'bold'}}>{res?.usedWholeCount}</span>
                    <span>次</span>
                  </>
                )}
              </>,
            className: 'custom-class',
            style: {
              marginTop: '35vh',
            },
          })
        }
      }
      form.resetFields()
      dispatch(setPageLoading(true))
      await dispatch(getRecipeDetail(recipeId))
      dispatch(setPageLoading(false))
    })
  }

  useEffect(() => {
    if (isSplitModalVisible) {
      document.addEventListener('keydown', handler)
      setTimeout(() => {
        buttonRef.current?.focus()
      }, 300)
    } else {
      document.removeEventListener('keydown', handler)
    }
    return () => {
      document.removeEventListener('keydown', handler)
    }
  }, [isSplitModalVisible])

  const setFieldsFromMaterial = (
    material: Material | undefined,
    isSpliting: boolean
  ) => {
    if (!material) {
      return
    }
    const groupNumber = localStorage.getItem('groupNumber')

    let m: any = {}
    const normalFrequency = material?.normalFrequency || ''
    const normalUsemethod = material?.normalUsemethod || ''
    const normalDose = material?.normalDose || ''
    if (settings?.[Checks.MLKG] == 1) {
      m = {
        ...material,
        splitTag: isSpliting && material.splitTag === 1 ? 1 : 0,
        normalDose: normalDose == -1 || normalDose == 0 ? '' : normalDose,
        groupNumber: 0,
        retailPrice: isSpliting ? material.splitPrice : material.retailPrice,
        useDays: material?.useDays == '0' ? 1 : material?.useDays || 1,
        normalFrequency: normalFrequency == -1 || normalFrequency == 0 ? '' : normalFrequency,
        normalUsemethod: normalUsemethod == -1 || normalUsemethod == 0 ? '' : normalUsemethod,
      } as Material
      setMaterial(m)
      const doseFixJDJZ = (m.normalDose > 0 && (m.normalUsemethod?.indexOf("静滴") >= 0 || m.normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
      const doseFixWH = (m.normalDose > 0 && (m.normalUsemethod?.indexOf("雾化") >= 0)) ? true : false
      const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS];

      let drugCount: any = m.drugCount

      try {
        if (m.normalDose && m.normalDose > 0 && m.frequencyCalc && m.frequencyCalc > 0 && autoChangePrice) {
            if (isSpliting && material.splitTag === 1) {
              drugCount = getNewAutoChangePriceSplitDrugCount('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, m.frequencyCalc, m.normalDose, m?.useDays || 1, flag)
            } else {
              drugCount = getNewAutoChangePriceDrugCount('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, m.frequencyCalc, m.normalDose, m?.useDays || 1, flag)
            }
        }
      } catch (e) {
        drugCount = m?.drugCount
      }
      if (drugCount == Infinity) {
        drugCount = 1;
      }
      if (!drugCount || drugCount <= 0) {
        drugCount = 1;
      }
      form.setFieldsValue({
        ...m,
        useDays: m?.useDays || 1,
        normalDose: m?.normalDose == -1 ? '' : m?.normalDose,
        drugCount: Math.floor(Number(drugCount)) || 1,
        groupNumber:
          (groupNumber && groupNumber != null && groupNumber != 'null') ? Number(groupNumber) || '' : '',
      })
    } else {
      m = {
        ...material,
        splitTag: isSpliting && material.splitTag === 1 ? 1 : 0,
        normalDose: normalDose == -1 || normalDose == 0 ? '' : normalDose,
        groupNumber: 0,
        drugCount: 1,
        retailPrice: isSpliting ? material.splitPrice : material.retailPrice,
        normalFrequency: normalFrequency == -1 || normalFrequency == 0 ? '' : normalFrequency,
        normalUsemethod:normalUsemethod == -1 || normalUsemethod == 0 ? '' : normalUsemethod,
      } as Material
      setMaterial(m)
      const doseConvert: any = material?.doseConvert && material?.doseConvert > 0 ? material?.doseConvert : ''

      const doseFixJDJZ = (m.normalDose > 0 && (m.normalUsemethod?.indexOf("静滴") >= 0 || m.normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
      const doseFixWH = (m.normalDose > 0 && (m.normalUsemethod?.indexOf("雾化") >= 0)) ? true : false
      const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS];

      let useDays: any =
        isSpliting && material.splitTag === 1
          ? (Number(m?.useDays) || 1) / doseConvert
          : m.useDays
      // 用量计算比没有填写的时候不进行计算
      if (!doseConvert) {
        useDays = m.useDays || 1
      }

      try {
        if (m.normalDose && m.normalDose > 0 && m.frequencyCalc && m.frequencyCalc > 0 && autoChangePrice) {
          // if (settings?.[Checks.MLKG] == 1) {
          //   if (isSpliting && material.splitTag === 1) {
          //     useDays = getNewAutoChangePriceSplitUseDays('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, 1, m.frequencyCalc, m.normalDose, flag)
          //   } else {
          //     useDays = getNewAutoChangePriceUseDays('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, 1, m.frequencyCalc, m.normalDose, flag)
          //   }
          // } else {
            if (isSpliting && material.splitTag === 1) {
              useDays = getOldAutoChangePriceSplitUseDays('', doseFixJDJZ, 1, m.frequencyCalc, m.normalDose)
            } else {
              useDays = getOldAutoChangePriceUseDays('', doseFixJDJZ, 1, m.frequencyCalc, m.normalDose, doseConvert)
            }
          // }
        }
      } catch (e) {
        useDays =
          isSpliting && material.splitTag === 1
            ? (Number(m?.useDays) || 1) / doseConvert
            : m.useDays
      }
      if (useDays == Infinity) {
        useDays = 1;
      }
      if (!useDays || useDays <= 0) {
        useDays = 1;
      }

      form.setFieldsValue({
        ...m,
        normalDose: m?.normalDose == -1 ? '' : m?.normalDose,
        // discount: m?.discount ? m?.discount : 100,
        useDays: Math.floor(Number(useDays)) || 1,
        // drugCount: autoChangePrice ? getDrugCount(material,isSpliting,useDays) : 1,
        groupNumber:
          (groupNumber && groupNumber != null && groupNumber != 'null') ? Number(groupNumber) || '' : '',
      })
    }

    // 剂量单位为"适量"时，清空剂量并置灰
    if (m.doseUnit === '适量') {
      setSelectDoseUnit(m?.doseUnit)
      form.setFieldsValue({ normalDose: '' })
    } else {
      setSelectDoseUnit(m?.doseUnit)
    }

    if (category == 3) {
      // 中药
      // 折扣
      const discount = form.getFieldValue('discount')
      // 数量
      const countPerTip = form.getFieldValue('countPerTip')
      setTCMDiscountAllPrice(
        (
          (discount ? Number(discount / 100) : 1) *
          ((m?.retailPrice ? Number(m?.retailPrice) : 0) *
            (countPerTip ? Number(countPerTip) : 1)) *
          Number(tipCount)
        )?.toFixed(2)
      )

      setTCMDiscountPrice(
        (
          (discount ? Number(discount / 100) : 1) *
          (m?.retailPrice ? Number(m?.retailPrice) : 0)
        )?.toFixed(5)
      )
    } else {
      // 西药
      // 折扣
      const discount = form.getFieldValue('discount')
      // 数量
      const drugCount = form.getFieldValue('drugCount')
      setDiscountAllPrice(
        (
          (discount ? Number(discount / 100) : 1) *
          ((m?.retailPrice ? Number(m?.retailPrice) : 0) *
            (drugCount ? Number(drugCount) : 1))
        )?.toFixed(2)
      )
      setDiscountPrice(
        (
          (discount ? Number(discount / 100) : 1) *
          (m?.retailPrice ? Number(m?.retailPrice) : 0)
        )?.toFixed(5)
      )
    }
  }

  // const getDrugCount = (m: Material, isSpliting: boolean,useDays: any) => {
  //   const doseFixJDJZ = (m?.normalDose > 0 && (m?.normalUsemethod?.indexOf("静滴") >= 0 || m?.normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
  //   const doseFixWH = (m?.normalDose > 0 && (m?.normalUsemethod?.indexOf("雾化") >= 0)) ? true : false;
  //   const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS];

  //   if (settings?.[Checks.MLKG] == 1) {
  //     if (isSpliting && m.splitTag === 1) {
  //       return getNewAutoChangePriceSplitDrugCount('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, m?.frequencyCalc, m?.normalDose, useDays, flag)
  //     } else {
  //       return getNewAutoChangePriceDrugCount('', m, m?.doseUnit, doseFixJDJZ, doseFixWH, m?.frequencyCalc, m?.normalDose, useDays, flag)
  //     }
  //   } else {
  //     return 1;
  //   }
  // }
  const [names, setNames] = useState<string[]>([])

  useEffect(() => {
    let names: string[] = []
    switch (category) {
      case RecipeCategory.Tcm:
      case RecipeCategory.TcmGranules:
        names = discountFlag ? [
          'normalUsemethod',
          'discount',
          'retailPrice',
          'countPerTip',
        ] : ['normalUsemethod', 'retailPrice', 'countPerTip']
        break
      case RecipeCategory.Dispose:
        names =  discountFlag? ['normalUsemethod', 'doseUnit', 'discount','retailPrice', 'drugCount'] : ['normalUsemethod', 'doseUnit', 'retailPrice', 'drugCount']
        break
      case RecipeCategory.TcmTreat:
        names =  ['groupNumber','useDays','retailPrice','drugCount']
        break
      default:
        names = discountFlag ? [
          'groupNumber',
          'normalUsemethod',
          'normalFrequency',
          'normalDose',
          'doseUnit',
          'useDays',
          'discount',
          'retailPrice',
          'drugCount',
        ] : [
          'groupNumber',
          'normalUsemethod',
          'normalFrequency',
          'normalDose',
          'doseUnit',
          'useDays',
          'retailPrice',
          'drugCount',
        ]
        break
    }
    setNames(names)
  }, [category])

 
  const requiredNamesForTreatment = ['retailPrice', 'drugCount']

  // 非西药
  const commonLeftList = ['useDays']
  const commonRightList = ['retailPrice','drugCount']

  const requiredNamesForMaterials  = materialsCategoryFlag && discountFlag ? [
      ...commonLeftList,
      'discount',
      ...commonRightList
    ] : [
      ...commonLeftList,
      ...commonRightList,
    ] 


  const refs = useRef<Array<RecipeItemFieldInputRef | null>>([])

  // 判断字段是否置灰（disabled），用于快捷键跳转时跳过
  const isFieldDisabled = (name: string) => {
    if (name === 'normalDose' && selectDoseUnit == '适量') return true
    if (name === 'discount') return false
    return material === undefined || (name === 'retailPrice' && !allowedToChangePrice)
  }

  useEffect(() => {
    refs.current.length = names.length
  }, [names])

  useEffect(() => {
    getCompletionType && getCompletionType(completionType)
  }, [completionType])

  useLayoutEffect(() => {
    if (!material || isSplitModalVisible) {
      return
    }
    const ref = refs.current[names.length - 1]
    ref?.focus()
    ref?.select()
  }, [material, isSplitModalVisible, names])

  return (
    <>
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          if(values?.name != selectData?.name){
            notification.info({
              message: '商品名称错误，请修改后再保存',
            })
            return
          } 
          onChange(
            {
              ...material,
              ...values,
              name: material?.name,
              drugCount: values?.drugCount || 1,
              discount: values?.discount,
              // retailPrice: discountFlag
              //   ? category == 3
              //     ? tcmDiscountPrice
              //     : discountPrice
              //   : values?.retailPrice,
              retailPrice: category == 3 ? tcmDiscountPrice : discountPrice,
            },
            isIgnoreStorage
          )
          setSelectData({})
          form.resetFields()
          form.setFieldsValue({
            discount: values?.discount,
          })
          setDiscountPrice('0.00')
          setDiscountAllPrice('0.00')
          setTCMDiscountPrice('0.00')
          setTCMDiscountAllPrice('0.00')
          setMaterial(undefined)
          setCalc(0)
          setSelectDoseUnit('')
        }}
        className={styles.form}
      >
        <Row
          wrap={false}
          gutter={kskdTag || ydkdFlag ? 20 : 30}
          style={{
            marginRight: 0,
            position: (hisVersion && 'fixed') as any,
            zIndex: 99,
          }}
        >
          <Col>
            <Row gutter={kskdTag || ydkdFlag ? 6 : 10}>
              <Col>
                {category == RecipeCategory.TcmTreat ? <></> :
                 category == RecipeCategory.Dispose ? (
                    <div
                      style={{
                        width: '6rem',
                        lineHeight: '2rem',
                        textAlign: 'center',
                        fontSize: '1rem',
                        backgroundColor: theme.c3,
                      }}
                    >
                      诊疗/材料
                    </div>
                ) : 
                category !== RecipeCategory.Tcm &&
                  category !== RecipeCategory.TcmGranules ? (
                  <Select
                    style={{
                      color: theme.tc1,
                      fontSize: '1rem',
                      width: '5rem',
                      height: '2rem',
                      backgroundColor: theme.c3,
                    }}
                    value={
                      completionType === ItemCompletionType.Treatment ? 1 : 0
                    }
                    onChange={(v) => {
                      if (v === 1) {
                        setCompletionType(ItemCompletionType.Treatment)
                      } else {
                        setCompletionType(ItemCompletionType.Auto)
                      }
                      setMaterial(undefined)
                      form.resetFields()
                      form.setFieldsValue({
                        discount: 100,
                      })
                    }}
                    bordered={false}
                    className={styles.select}
                  >
                    <Select.Option value={0}>药品</Select.Option>
                    <Select.Option value={1}>诊疗</Select.Option>
                  </Select>
                ) : (
                  <div
                    style={{
                      width: '5rem',
                      lineHeight: '2rem',
                      textAlign: 'center',
                      fontSize: '1rem',
                      backgroundColor: theme.c3,
                    }}
                  >
                    药品
                  </div>
                )}
              </Col>
              <Col>
                {recipes?.length == 0 && data?.length === 0 ? (
                  <>
                    <Form.Item noStyle name='name'>
                      <RecipeItemInput
                        placeholder={completionType != ItemCompletionType.Treatment ? (settings?.[Checks.YPSSFS] === '1' ? '名称/助记码/追溯码' : '名称/助记码/条形码') :'名称/助记码' }
                        searfhTcFlag={true} //是否搜索套餐的标志
                        selectTag={selectTag}
                        isRestrictUser={1} //是否限制用户
                        wbTag={wbTag}
                        potionType={potionType}
                        insuranceCode={insuranceCode}
                        isShowPageChange={true}
                        disabled
                        patientPhone={patientPhone}
                        style={{
                          width: '12rem',
                          height: '2rem',
                          color: theme.tc1,
                        }}
                        autoFocus
                        type={completionType}
                        category={category}
                      />
                    </Form.Item>
                  </>
                ) : (
                  <Form.Item noStyle name='name'>
                    <RecipeItemInput
                      isMember={isMember}
                      placeholder={completionType != ItemCompletionType.Treatment ? (settings?.[Checks.YPSSFS] === '1' ? '名称/助记码/追溯码' : '名称/助记码/条形码') :'名称/助记码' }
                      searfhTcFlag={true} //是否搜索套餐的标志
                      selectTag={selectTag}
                      isRestrictUser={1}
                      wbTag={wbTag}
                      potionType={potionType}
                      insuranceCode={insuranceCode}
                      ref={ref}
                      patientPhone={patientPhone}
                      isShowPageChange={true}
                      disabled={disabled}
                      ydkdFlag={ydkdFlag}
                      style={{
                        width: '12rem',
                        height: '2rem',
                        color: theme.tc1,
                      }}
                      autoFocus
                      type={completionType}
                      category={category}
                      useSpecifiedBatch={
                        isTcmRecipeCategory(category)
                          ? tcmUseSpecifiedBatch
                          : useSpecifiedBatch
                      }
                      ignoreStorage={
                        isTcmRecipeCategory(category)
                          ? tcmIgnoreStorage
                          : ignoreStorage
                      }
                      includeAllTcm={includeAllTcm}
                      onSelect={(m, ignoreStorage) => {
                        setSelectData(m)
                        if(m?.isGoodsCombo){
                          dispatch(getSetMealDetail(m.id))
                            .then(unwrapResult)
                            .then((v:any) => {
                              form.resetFields()
                              addTC &&
                                addTC(
                                  v,
                                  m?.id,
                                  category,
                                  true,
                                  m,
                                )
                            })
                        } else {
                          const calc = settings?.[Checks.MLKG] == 1 ? getNewNormalFrequencyCodeCalc(m?.normalFrequency) || 0 : getNormalFrequencyCodeCalc(m?.normalFrequency) || 0
                          setCalc(calc)
                          if (
                            insuranceCode &&
                            !m.hilistCode &&
                            insuranceCode !== 'ZIFEI' &&
                            treatmentInsuranceCode !== 'ZIFEI'
                          ) {
                            notification.warn({
                              message:
                                m.name +
                                '未匹配医保编码或匹配过期，仅支持自费结算',
                              duration: 6,
                            })
                          }
                          const mData = { ...m, useDays: m?.useDays == '-1' ? '1' : m?.useDays }
                          setMaterial(mData)
                          setIsIgnoreStorage(ignoreStorage)
                          // 选中瞬间同步让搜索框失焦，避免快速输入落回药品搜索框
                          ref.current?.blur()
                          if (m.splitTag === 1) {
                            // 序号拆零
                            setIsSplitModalVisible(true)
                          } else {
                            setFieldsFromMaterial(mData, false)
                          }
                        }
                      }}
                      onPressEnter={(v) => {
                        if(category == RecipeCategory.Tcm || category == RecipeCategory.TcmGranules){
                          return
                        }
                        // 防抖：如果正在加载中，则不响应
                        if(isTraceCodeLoading) {
                          return
                        }
                        const currentvalue = form.getFieldValue('name')
                        setTraceCode(currentvalue)
                        if(currentvalue?.startsWith('8') && currentvalue?.length >= 20) {
                          // 满足条件：8开头且>= 20位，仅调用quicklyPrescribeBySpecialWa接口
                          // 标记开始加载
                          setIsTraceCodeLoading(true)
                          dispatch(getQuicklyPrescribeBySpecialWayFn({
                            type: 0,
                            code: currentvalue,
                            treatmentId: Number(treatmentId),
                            recipeId: Number(recipeId),
                            createAutoFeeSwitch: createAutoFeeSwitch?.[56] == 'true' ? true : false
                          })).then(unwrapResult)
                          .then(async (res: any)=>{  
                            if(res.code == 101) {
                              setIsTraceCodeTag(true)
                              setTraceCodeData(res)
                              setIsSplitModalVisible(true)
                            } else if(res.code == 201) { 
                              notification.error({
                                message: res.msg,
                                duration: 3,
                              })
                            } else if(res.code == 200) {
                              // 处理code == 200的情况，显示使用次数提醒
                              if (res?.usedSplitCount > 0 || res?.usedWholeCount > 0) {
                                message.open({
                                  type: 'warning',
                                  content:
                                    <>
                                      <span>{res?.name}</span>
                                      <span style={{margin:'0 4px'}}>追溯码</span>
                                      <span>{res?.traceCode}</span>
                                      <span style={{margin:'0 4px'}}></span>
                                      {res?.usedSplitCount > 0 && (
                                        <>
                                          <span>拆零已录入</span>
                                          <span style={{color:'#ff9f39',fontWeight:'bold'}}>{res?.usedSplitCount}</span>
                                          <span>次</span>
                                        </>
                                      )}
                                      {res?.usedSplitCount > 0 && res?.usedWholeCount > 0 && (
                                        <span style={{margin:'0 4px'}}>，</span>
                                      )}
                                      {res?.usedWholeCount > 0 && (
                                        <>
                                          <span>整存已录入</span>
                                          <span style={{color:'#ff9f39',fontWeight:'bold'}}>{res?.usedWholeCount}</span>
                                          <span>次</span>
                                        </>
                                      )}
                                    </>,
                                  className: 'custom-class',
                                  style: {
                                    marginTop: '35vh',
                                  },
                                })
                              }
                              dispatch(setPageLoading(true))
                              await dispatch(getRecipeDetail(recipeId))
                              dispatch(setPageLoading(false))
                            } else {
                              dispatch(setPageLoading(true))
                              await dispatch(getRecipeDetail(recipeId))
                              dispatch(setPageLoading(false))
                            }
                            // 接口调用完成后清空输入框
                            form.setFieldsValue({ name: '' })
                            // 调用完成，标记加载结束
                            setIsTraceCodeLoading(false)
                          })
                          .catch((error)=>{
                            console.log('失败了', error);
                            // 错误情况下也清空输入框
                            form.setFieldsValue({ name: '' })
                            // 错误时也要标记加载结束
                            setIsTraceCodeLoading(false)
                          })
                          // 满足条件时不再执行其他逻辑，直接返回
                          return
                        }
                      }}
                    />
                  </Form.Item>
                )}
              </Col>
              {names?.map((n, i) => (
                <Col key={n}>
                  <Form.Item
                    name={n}
                    required={true} 
                     rules={[
                      {
                        required:
                         materialsCategoryFlag ? requiredNamesForMaterials?.includes(n) :
                         n == 'normalDose' && selectDoseUnit == '适量' ? false :
                          n !== 'groupNumber' &&
                          n !== 'doseUnit' &&
                          ((completionType !== ItemCompletionType.Treatment && category !== RecipeCategory.Dispose) ||
                            requiredNamesForTreatment.includes(n)),
                      },
                    ]}
                    className={styles.field}
                  >
                    <RecipeItemFieldInput
                      yzcfkf={true}//列表编辑剂量单位的标志(展示方式跟别的单位不一样)
                      editTableDoseUnit={false}
                      selectData={selectData}
                      currentDoseUnit={selectDoseUnit}
                      ref={(elem) => (refs.current[i] = elem)}
                      field={n}
                      recipeCategory={category}
                      disabled={
                        n == 'normalDose' && selectDoseUnit == '适量' ? true :
                        n === 'discount'
                          ? false
                          : material === undefined ||
                            (n === 'retailPrice' && !allowedToChangePrice) 
                      }
                      onPressEnter={() => {
                        const nextEmptyIndex = names.slice(i + 1).findIndex((name) => !form.getFieldValue(name) && !isFieldDisabled(name));
                        const nextIndex =  nextEmptyIndex !== -1 ? i + 1 + nextEmptyIndex : names.length - 1;
                        const ref = refs.current[nextIndex];
                        ref?.focus();
                        if (i + 1 >= names.length) {
                          if (category == RecipeCategory.Tcm  || category == RecipeCategory.TcmGranules ? form.getFieldValue('countPerTip') != 0 : form.getFieldValue('drugCount') != 0 ) {
                            form.submit()
                            const firstEmptyIndex = names.findIndex(
                              (name) =>
                                !form.getFieldValue(name) &&
                                !isFieldDisabled(name) &&
                                name !== 'groupNumber' &&
                                name !== 'doseUnit' &&
                                ((completionType !== ItemCompletionType.Treatment &&
                                  category !== RecipeCategory.Dispose) ||
                                  requiredNamesForTreatment.includes(name))
                            );
                            if (firstEmptyIndex !== -1) {
                              refs.current[firstEmptyIndex]?.focus();
                            }
                          } else {
                            notification.error({
                              message: category == RecipeCategory.Tcm ? '每帖数量不可为 0' : '数量不可为 0',
                              duration: 2,
                            })
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        // 用法频次下拉打开时，不跳转，让下拉自己处理键盘事件
                        if ((n == 'normalFrequency' || n == 'normalUsemethod') && refs.current[i]?.isDropdownOpen?.()) {
                          return
                        }
                        // 左右箭头：一次跳一个字段
                        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                          e.preventDefault()
                          const direction = e.key === 'ArrowRight' ? 1 : -1
                          let targetIndex = i + direction
                          while (targetIndex >= 0 && targetIndex < names.length && isFieldDisabled(names[targetIndex])) {
                            targetIndex += direction
                          }
                          if (targetIndex >= 0 && targetIndex < names.length) {
                            refs.current[targetIndex]?.focus()
                            refs.current[targetIndex]?.select()
                          }
                        }
                      }}
                      onChange={(v: any, pc: any) => {
                        if (n == 'groupNumber') {
                          localStorage.setItem('groupNumber', v)
                        }
                        if (n == 'doseUnit') {
                          setSelectDoseUnit(v)
                          if (v == '适量') {
                            form.setFieldsValue({
                              normalDose: '',
                            })
                          }
                        }
                        const normalDose = form.getFieldValue('normalDose')
                        const normalUsemethod = form.getFieldValue('normalUsemethod')
                        const normalFrequency = settings?.[Checks.MLKG] == 1 ? getNewNormalFrequencyCodeCalc(form.getFieldValue('normalFrequency')) || 0 : getNormalFrequencyCodeCalc(form.getFieldValue('normalFrequency')) || 0 
                        const formUseDays = form.getFieldValue('useDays')
                        const formDrugCount = form.getFieldValue('drugCount')
                        const doseFixJDJZ = (normalDose > 0 && (normalUsemethod?.indexOf("静滴") >= 0 || normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
                        const doseFixWH = (normalDose > 0 && (normalUsemethod?.indexOf("雾化") >= 0)) ? true : false;
                        const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS];
                        const frequencyCalc: any = pc || normalFrequency || material?.frequencyCalc || 0

                        //先走自动计算数量/天数的逻辑，然后再计算折扣
                        if (autoChangePrice) {
                          const doseUnit = form.getFieldValue('doseUnit') //剂量单位
                          if (pc == 0 || doseUnit == '适量') {
                            form.setFieldsValue({
                              [n]: v,
                            })
                            return
                          }
                          if (settings?.[Checks.MLKG] == 1) {
                            //  只对药品进行计算
                            if (v && material && material.materialsCategory == 0) {
                              if (!doseUnit) {
                                form.setFieldsValue({
                                  [n]: v,
                                })
                                return
                              }
                              if (n === 'drugCount') {
                                if (frequencyCalc != 0) {
                                  const useDays = getNewAutoChangePriceUseDays(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, v, frequencyCalc, normalDose, flag)
                                  const splitUseDays = getNewAutoChangePriceSplitUseDays(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, v, frequencyCalc, normalDose, flag)
                                  const realUseDays: any = material?.splitTag == 1 ? splitUseDays : useDays
                                  form.setFieldsValue({
                                    useDays: realUseDays != 'Infinity' ? Math.floor(realUseDays < 1 ? 1 : realUseDays) || 1 : undefined,
                                  })
                                } else {
                                  form.setFieldsValue({
                                    drugCount: v,
                                  })
                                }
                              } else {
                                let drugCount: any = 0
                                let splitDrugCount: any = 0
                                if (n === 'normalFrequency') {
                                  drugCount = getNewAutoChangePriceDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, formUseDays, flag)
                                  splitDrugCount = getNewAutoChangePriceSplitDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, formUseDays, flag)
                                } else if (n === 'normalDose') {
                                  drugCount = getNewAutoChangePriceDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, v, formUseDays, flag)
                                  splitDrugCount = getNewAutoChangePriceSplitDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, v, formUseDays, flag)
                                } else if (n === 'useDays') {
                                  drugCount = getNewAutoChangePriceDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, v, flag)
                                  splitDrugCount = getNewAutoChangePriceSplitDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, v, flag)
                                } else if (n === 'doseUnit') {
                                  drugCount = getNewAutoChangePriceDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, formUseDays, flag)
                                  splitDrugCount = getNewAutoChangePriceSplitDrugCount(n, selectData, doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, normalDose, formUseDays, flag)
                                } else if (n === 'normalUsemethod') {
                                  drugCount = formDrugCount
                                  splitDrugCount = formDrugCount
                                }
                                const realDrugCount =
                                  material?.splitTag == 1
                                    ? splitDrugCount != 'Infinity' ? splitDrugCount : 1
                                    : drugCount != 'Infinity' ? drugCount : 1
                                form.setFieldsValue({
                                  drugCount: realDrugCount || 1,
                                })
                              }
                            } else {
                              form.setFieldsValue({
                                [n]: v,
                              })
                            }
                          } else {
                            // 只对药品进行计算
                            if (v && material && material.materialsCategory == 0) {
                              // 用量计算比没有填写的时候不进行计算
                              const doseConvert: any = material?.doseConvert && material?.doseConvert > 0 ? material?.doseConvert : ''
                              if (!doseConvert) {
                                form.setFieldsValue({
                                  [n]: v,
                                })
                              }
                              if (n === 'drugCount') {
                                if (calc !== 0) {
                                  //特殊用法剂量修正
                                  const useDays = getOldAutoChangePriceUseDays(n, doseFixJDJZ, v, calc, normalDose, doseConvert)
                                  const splitUseDays = getOldAutoChangePriceSplitUseDays(n, doseFixJDJZ, v, calc, normalDose)

                                  const realUseDays: any = material?.splitTag == 1 ? splitUseDays : useDays

                                  form.setFieldsValue({
                                    useDays: realUseDays != 'Infinity' ? Math.floor(realUseDays < 1 ? 1 : realUseDays) || 1 : undefined,
                                  })
                                } else {
                                  form.setFieldsValue({
                                    drugCount: v,
                                  })
                                }
                              } else {
                                let drugCount: any = 0
                                let splitDrugCount: any = 0
                                if (n === 'normalFrequency') {
                                  //  频次修改
                                  drugCount = getOldAutoChangePriceDrugCount(n, doseFixJDJZ, formUseDays, frequencyCalc, normalDose, doseConvert)
                                  splitDrugCount = getOldAutoChangePriceSplitDrugCount(n, doseFixJDJZ, formUseDays, frequencyCalc, normalDose)
                                  setCalc(pc || 0)
                                } else if (n === 'normalDose') {
                                  drugCount = getOldAutoChangePriceDrugCount(n, doseFixJDJZ, formUseDays, '', v, doseConvert, frequencyCalc)
                                  splitDrugCount = getOldAutoChangePriceSplitDrugCount(n, doseFixJDJZ, formUseDays, '', v, frequencyCalc)
                                } else if (n === 'useDays') {
                                  drugCount = getOldAutoChangePriceDrugCount(n, doseFixJDJZ, v, '', normalDose, doseConvert, frequencyCalc)
                                  splitDrugCount = getOldAutoChangePriceSplitDrugCount(n, doseFixJDJZ, v,'', normalDose, frequencyCalc)
                                } else if (n === 'normalUsemethod' || n === 'doseUnit' || n === 'retailPrice') {
                                  drugCount = formDrugCount
                                  splitDrugCount = formDrugCount
                                }
                                const realDrugCount =
                                  material?.splitTag == 1
                                    ? splitDrugCount != 'Infinity' ? splitDrugCount : 1
                                    : drugCount != 'Infinity' ? drugCount : 1
                                form.setFieldsValue({
                                  drugCount: realDrugCount || 1,
                                })
                              }
                            } else {
                              form.setFieldsValue({
                                [n]: v,
                              })
                            }
                          }
                        } else {
                          form.setFieldsValue({
                            [n]: v,
                          })
                        }
                        //进行折扣计算（没有折扣时默认为1)
                        if (category == 3) {
                          // 中药数量
                          const countPerTips = form.getFieldValue('countPerTip')
                          const discounts = form.getFieldValue('discount')
                          const retailPrices = form.getFieldValue('retailPrice')
                          // 折扣
                          const discount = discounts ? Number(discounts) / 100 : 1
                          // 单价
                          const retailPrice = retailPrices ? Number(retailPrices) : 0
                          // 数量
                          const countPerTip = countPerTips ? Number(countPerTips) : 1
                          setTCMDiscountPrice(
                            (discount * (retailPrice ? Number(retailPrice) : 0))?.toFixed(5)
                          )
                          setTCMDiscountAllPrice((discount * retailPrice * countPerTip * Number(tipCount))?.toFixed(2))
                        } else {
                          // 西药数量
                          const drugCounts = form.getFieldValue('drugCount')
                          const discounts = form.getFieldValue('discount')
                          const retailPrices = form.getFieldValue('retailPrice')
                          // 折扣
                          const discount = discounts ? Number(discounts) / 100 : 1
                          // 单价
                          const retailPrice = retailPrices ? Number(retailPrices) : 0
                          // 数量
                          const drugCount = drugCounts ? Number(drugCounts) : 1

                          setDiscountPrice(
                            (discount * (retailPrice ? Number(retailPrice) : 0))?.toFixed(5)
                          )
                          setDiscountAllPrice(
                            (discount * retailPrice * drugCount)?.toFixed(2)
                          )
                        }
                      }}
                      kskdTag={kskdTag}
                      ydkdFlag={ydkdFlag}
                    />
                  </Form.Item>
                </Col>
              ))}
              {/* {settings?.[Checks.MLKG] == 1 ?
               <Select>
                 {unitList?.map((v:any) => (
                  <Select.Option key={v.name} value={v.name} >
                    {v.name}
                  </Select.Option>
                ))}
               </Select>
               : */}
              <Col
                style={{
                  fontSize: '1rem',
                  height: '2rem',
                  lineHeight: '2rem',
                  padding: '0 8px',
                  minWidth: '2rem',
                  borderTopRightRadius: 4,
                  borderBottomRightRadius: 4,
                  marginLeft: -5,
                  borderTop: `solid 1px ${theme.wbd}`,
                  borderRight: `solid 1px ${theme.wbd}`,
                  borderBottom: `solid 1px ${theme.wbd}`,
                }}
              >
                {material?.splitTag === 1
                  ? material?.splitUnit
                  : material?.accountUnit}
              </Col>
              
            </Row>
          </Col>
          {discountFlag ? (
            <Col
              style={{
                borderBottom: '1px solid #EEEEEE ',
              }}
            >
              <div
                style={{
                  height: '2rem',
                  fontWeight: 'bold',
                  fontSize: '22px',
                }}
              >
                <span style={{ color: '#101010' }}>¥</span>
                <span
                  style={{
                    color: '#a9633b',
                    padding: '10px',
                  }}
                >
                  {category == 3 ? tcmDiscountAllPrice : discountAllPrice}
                </span>
              </div>
            </Col>
          ) : (
            ''
          )}

          <Col>
            <Button
              type='primary'
              disabled={!category}
              onClick={() => {
                if (category == RecipeCategory.Tcm || category == RecipeCategory.TcmGranules ? form.getFieldValue('countPerTip') != 0 : form.getFieldValue('drugCount') != 0) {
                  form.submit()
                  const firstEmptyIndex = names.findIndex(
                    (name) =>
                      !form.getFieldValue(name) &&
                      name !== 'groupNumber' &&
                      name !== 'doseUnit' &&
                      ((completionType !== ItemCompletionType.Treatment &&
                        category !== RecipeCategory.Dispose) ||
                        requiredNamesForTreatment.includes(name))
                  );
                  if (firstEmptyIndex !== -1) {
                    refs.current[firstEmptyIndex]?.focus();
                  }
                } else {
                  notification.error({
                    message: category == RecipeCategory.Tcm ? '每帖数量不可为 0' : '数量不可为 0',
                    duration: 2,
                  })
                }
              }}
              style={{
                height: '2rem',
              }}
            >
              添加
            </Button>
            {category == RecipeCategory.Dispose && !isCurePlanModa && (
              <Button
                type='primary'
                loading={quickAddProjectLoading}
                onClick={() => {
                  quickAddProject && quickAddProject()
                }}
                style={{
                  height: '2rem',
                  marginLeft: '10px',
                  background: '#FF8345',
                  border: '1px solid #FF8345'
                }}
              >
                快速添加项目
              </Button>
            )}
          </Col>
        </Row>
      </Form>
       <Modal
        title='可选单位'
        className={styles.split}
        visible={isSplitModalVisible}
        onCancel={() => {
          // if (settings?.[Checks.MLKG] === '1' && completionType != ItemCompletionType.Treatment) {
          //   // 非诊疗跳天数
          //   setTimeout(() => {
          //     const useDaysIndex = names.indexOf('useDays')
          //     const ref = refs.current[useDaysIndex !== -1 ? useDaysIndex : names.length - 1]
          //     ref?.focus()
          //   }, 10)
          // } else {
            setTimeout(() => {
              const ref = refs.current[names.length - 1]
              ref?.focus()
              // ref?.select()
            }, 300)
          // }
          setIsSplitModalVisible(false)
        }}
        footer={null}
      >
        <Space direction='vertical'>
          <Button
            type='primary'
            onClick={() => {
              if(isTraceCodeTag) {
                traceCodeHandler(1)
              }
              setFieldsFromMaterial(material, true)
              setIsSplitModalVisible(false)
              // if (settings?.[Checks.MLKG] === '1' && completionType != ItemCompletionType.Treatment) {
              //   // 非诊疗跳天数
              //   setTimeout(() => {
              //     const useDaysIndex = names.indexOf('useDays')
              //     const ref = refs.current[useDaysIndex !== -1 ? useDaysIndex : names.length - 1]
              //     ref?.focus()
              //   }, 10)
              // } else {
                setTimeout(() => {
                  const ref = refs.current[names.length - 1]
                  ref?.focus()
                  // ref?.select()
                }, 300)
              // }
            }}
          >
            <span
              style={{
                backgroundColor: theme.pn,
                borderRadius: 999,
                color: theme.c1,
                lineHeight: '1rem',
                marginRight: 8,
                textAlign: 'center',
                width: '1rem',
              }}
            >
              1
            </span>
            {`${(isTraceCodeTag ? traceCodeData?.splitPrice : material?.splitPrice) || ''}元/${(isTraceCodeTag ? traceCodeData?.splitUnit : material?.splitUnit) || ''}`}
          </Button>
          <Button
            ref={buttonRef}
            type='primary'
            onClick={() => {
              if(isTraceCodeTag) {
                traceCodeHandler(0)
              }
              setFieldsFromMaterial(material, false)
              setIsSplitModalVisible(false)
              // if (settings?.[Checks.MLKG] === '1' && completionType != ItemCompletionType.Treatment) {
              //   // 非诊疗跳天数
              //   setTimeout(() => {
              //     const useDaysIndex = names.indexOf('useDays')
              //     const ref = refs.current[useDaysIndex !== -1 ? useDaysIndex : names.length - 1]
              //     ref?.focus()
              //   }, 10)
              // } else {
                setTimeout(() => {
                  const ref = refs.current[names.length - 1]
                  ref?.focus()
                  // ref?.select()
                }, 300)
              // }
            }}
          >
            <span
              style={{
                backgroundColor: theme.pn,
                borderRadius: 999,
                color: theme.c1,
                lineHeight: '1rem',
                marginRight: 8,
                textAlign: 'center',
                width: '1rem',
              }}
            >
              2
            </span>
            {`${(isTraceCodeTag ? traceCodeData?.retailPrice : material?.retailPrice) || ''}元/${isTraceCodeTag ? traceCodeData?.accountUnit : material?.accountUnit || ''}`}
          </Button>
        </Space>
        <div className={styles.hint}>可键盘选择“1”或“2”</div>
      </Modal>
    </>
  )
}
